import React from 'react';
import { generateAiVerdict } from './utils/aiVerdictGenerator';

export default function InvestmentSummary({ baseline, signals, market, subscores, onOpenAi }) {
  if (!baseline) return null;

  const chancen = signals?.filter(s => s.type === 'positive')?.length ?? 0;
  const risiken = signals?.filter(s => s.type === 'risk' || s.type === 'caution')?.length ?? 0;

  const verdict = generateAiVerdict(baseline, signals, market, subscores);

  return (
    <div
      className="rounded-2xl p-6"
      style={{
        background: '#F3F3F5',
        border: '1px solid #E0E0DF',
        borderRadius: 16,
      }}
    >
      {/* Section-Headline */}
      <h3
        className="mb-4"
        style={{
          fontSize: 20,
          fontWeight: 600,
          lineHeight: '30px',
          color: '#1F1F1F',
        }}
      >
        Investitionsübersicht
      </h3>

      {/* AI-Interpretation */}
      {verdict && (
        <p
          className="mb-4"
          style={{
            fontSize: 16,
            fontWeight: 400,
            lineHeight: '24px',
            color: '#5D5D6D',
            display: '-webkit-box',
            WebkitLineClamp: 3,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
          }}
        >
          {verdict}
        </p>
      )}

      {/* Signal-Zusammenfassung */}
      <div className="flex gap-5 mb-5">
        <span style={{ fontSize: 14, fontWeight: 600, lineHeight: '20px', color: '#1F1F1F' }}>
          <span style={{ color: '#1FA534' }}>{chancen}</span> Chancen erkannt
        </span>
        <span style={{ fontSize: 14, fontWeight: 600, lineHeight: '20px', color: '#1F1F1F' }}>
          <span style={{ color: '#E83838' }}>{risiken}</span> Risiken erkannt
        </span>
      </div>

      {/* CTA-Zeile */}
      <div className="flex items-center gap-3">
        {/* Typ 1: Primary Button — Deal speichern */}
        <button
          className="flex items-center gap-1.5 rounded-lg text-[15px] font-semibold text-white transition-all"
          style={{ background: '#1DB3B3', padding: '10px 20px', border: 'none', cursor: 'pointer' }}
          onMouseEnter={(e) => { e.currentTarget.style.background = '#0E7A6B'; }}
          onMouseLeave={(e) => { e.currentTarget.style.background = '#1DB3B3'; }}
        >
          Deal speichern
        </button>

        {/* Typ 3: Ghost Button — AI fragen */}
        {onOpenAi && (
          <button
            onClick={onOpenAi}
            className="flex items-center gap-1 rounded-md text-[14px] font-medium transition-all"
            style={{ background: 'transparent', border: 'none', color: '#1DB3B3', padding: '6px 8px', cursor: 'pointer' }}
            onMouseEnter={(e) => { e.currentTarget.style.background = '#E8F7F7'; e.currentTarget.style.color = '#0E7A6B'; }}
            onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#1DB3B3'; }}
          >
            AI fragen
            <svg width="13" height="13" viewBox="0 0 13 13" fill="none" style={{ marginLeft: 4 }}>
              <path d="M2 6.5h9M8 3.5L11 6.5 8 9.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        )}
      </div>
    </div>
  );
}
